<template>
    <div class="users-style roster-leave-policies-page">

        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance Settings<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance Settings / Leave & Attendance Policy</span>
        </h4>

        <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>

        <div class="mt-4 ibox p-3">
          <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0 pt-0 pb-0 roster-ibox">
              <h4 class="clearfix mb-0">
                  <span class="float-left">Leave & Attendance Policy
                      <span class="title-sub-text"></span>
                  </span>
                  <span class="float-right"></span>
              </h4>
          </div>
          <div class="row no-gutters py-2 mb-3 pl-0 ">
              <div class="col-sm-6">
                  <div class="custom-search">
                      <b-input-group class="mb-2">
                          <b-input-group-prepend is-text>
                              <b-icon icon="search"></b-icon>
                          </b-input-group-prepend>
                          <b-form-input type="search" placeholder="Search.. " v-model="search" @input="resetPagination()"></b-form-input>
                      </b-input-group>
                  </div>
              </div>
              <div class="col-sm-6 pr-0 cursor-pointer text-right company-form-box-title" >
                  <b-button id="show-btn" v-if="ce" @click="addNewLeavePolicy()"><b-icon icon="plus" ></b-icon> Add Leave & Attendance Policy</b-button>
              </div>
          </div>

          <b-overlay :show="showoverlay" rounded="sm">
              <table class="table dataTable">
                  <thead>
                      <tr class="table-head">

                          <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey == column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" class="cursor-pointer"><span>{{column.label}}</span></th>
                          <th class="text-right" >Actions</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr class="hover-bg table-row border-bottom mx-2" v-for="leavepolicy in paginatedData" :key="leavepolicy.id">
                          <td>{{leavepolicy.title}}</td>
                          <td>{{employeeTypes[leavepolicy.is_roster]}}</td>
                          <td>{{leavepolicy.holiday == 1 ? 'Yes' : 'No'}}</td>
                          <td >

                              <div class="float-right position-relative">
                                  <b-button-toolbar>
                                      <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                      <div class="dropdown-menu action-dropdown-menu px-1" aria-labelledby="actionDropdown">
                                          <b-button-group >
                                              <b-button variant="outline-secondary"  v-if="ce" @click="editLeavePolicy(leavepolicy.id)">
                                                  <b-icon icon="pencil"></b-icon> Edit
                                              </b-button>
                                              <b-button variant="outline-secondary"  v-if="ce" @click="deleteLeavePolicy(leavepolicy.id)">
                                                  <b-icon icon="trash"></b-icon> Delete
                                              </b-button>
                                          </b-button-group>
                                      </div>
                                  </b-button-toolbar>
                              </div>
                          </td>
                      </tr>
                  </tbody>
              </table>
                <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                    <div class="col-md-12 p-0 no-margin">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled">
                                <b-form-select v-model="temp_length" :options="length_options"></b-form-select>
                            </li>
                            <li class="page-item disabled m-2">per page. Total {{ people }} records found.</li>
                        </ul>
                        <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number></b-pagination-nav>
                    </div>
                </div>

                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span class="d-block text-center">{{blankmsg}}</span>
                </div>
          </b-overlay>
        </div>



        <b-modal id="bv-modal-leave_policies" size="md" hide-footer :title="modalTitle">
          <b-overlay :show="showoverlaymodal" rounded="sm">
            <div class="users-style roster-leave-policies-page">
              <b-form @submit.stop.prevent="onSubmit">
                  <input type="hidden" v-model="fdata.id" name="id">
                <div class=" row">
                  <div class="col-sm-12">
                    <b-form-group id="title-group" label="Title" label-for="title">
                      <b-form-input id="title" name="title" v-model="fdata.title" v-validate="{ required: true, min: 3 }" :state="validateState('title')" aria-describedby="title-feedback" data-vv-as="Title"></b-form-input>
                      <b-form-invalid-feedback id="title-feedback">{{ veeErrors.first('title') }}</b-form-invalid-feedback>
                    </b-form-group>
                  </div>

                  <div class="col-sm-12">
                    <label>Leave Categories</label>

                    <div class="position-relative" ref="leave_type_dropdown">
                      <button type="button" class="form-control d-flex justify-content-between align-items-center text-left overflow-hidden bg-white cursor-pointer assignment-toggle" @click.prevent="toggleLeaveTypeDropdown">
                        <span
                          class="assignment-toggle-label d-block overflow-hidden"
                          :class="fdata.leave_type_ids && fdata.leave_type_ids.length ? 'has-selection' : 'is-placeholder'"
                        >
                          {{ fdata.leave_type_ids && fdata.leave_type_ids.length ? getSelectedLeaveTypeNames() : 'Select Leave Categories' }}
                        </span>

                        <b-icon class="ml-3 assignment-toggle-caret custom-caret" icon="chevron-down"></b-icon>
                      </button>

                      <div class="assignment-menu position-absolute rounded p-2 bg-white ibox" v-if="openLeaveTypeDropdown">
                        <label v-for="leave_type in leavetypes" :key="leave_type.id" class="assignment-option d-flex align-items-center cursor-pointer p-1 m-0 font-weight-normal rounded">
                          <input class="assignment-checkbox" type="checkbox" :value="leave_type.id" v-model="fdata.leave_type_ids"/>
                          <span>{{ leave_type.title }}</span>
                        </label>
                      </div>
                    </div>
                  </div>



                    </div>

                    <div class="row bg-wash rounded mx-0 roster-leave-policy-modal mt-3">
                        <div class="col-sm-12" v-if="roster == 1">
                            <b-form-group label="Employee Type" label-class="mb- pt-3" class="leave-attendance-legends col-12">
                                <b-form-radio-group
                                    id="employee_type"
                                    name="employee_type"
                                    class="leave-attendance-btns w-100"
                                    v-model="fdata.is_roster"
                                    :options="employeeTypeOptions"
                                    buttons
                                    button-variant="outline-secondary">
                                </b-form-radio-group>
                            </b-form-group>
                        </div>

                        <div class="col-sm-12 approve-level-content py-0 px-3" :class="fdata.is_roster == '0' ? 'mb-3' : ''">
                            <div class="d-flex flex-row justify-content-between border-bottom align-items-center">
                                <div>
                                    <p class="salary-heads my-2">Allow <strong>Long Service Leave</strong></p>
                                </div>
                                <div>
                                    <b-form-checkbox class="roster-small-switch" id="long_service_status" v-model="fdata.long_service_status" size="lg" name="long_service_status" switch :value="1" :unchecked-value="0"/>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-6" v-if="fdata.is_roster == 0">
                            <b-form-group id="shift_id-group" label="Office Time" label-for="shift_id">
                            <b-form-select id="shift_id" name="shift_id" v-model="fdata.shift_id"
                            :options="shiftData"></b-form-select>
                            </b-form-group>
                        </div>

                        <div class="col-sm-6" v-if="fdata.is_roster == 0">
                            <b-form-group id="offday_id-group" label="Off Day template" label-for="offday_id">
                            <b-form-select id="offday_id" name="offday_id" v-model="fdata.offday_id"
                            :options="patternOptions"></b-form-select>
                            </b-form-group>
                        </div>

                        <div class="col-sm-12 approve-level-content py-0 mb-3 px-3" v-if="fdata.is_roster">
                            <div class="d-flex flex-row justify-content-between border-bottom align-items-center">
                            <div>
                                <p class="salary-heads my-2">Holiday <strong>Enable</strong></p>
                            </div>
                            <div>
                                <b-form-checkbox class="roster-small-switch" id="holiday" v-model="fdata.holiday" size="lg" name="holiday" switch :value="1" :unchecked-value="0"/>
                            </div>
                            </div>
                        </div>

                        <div class="col-sm-6" v-if="overtime == 1">
                            <b-form-group id="ot_policy_id-group" label="Overtime Policy" label-for="ot_policy_id">
                            <b-form-select id="ot_policy_id" name="ot_policy_id" v-model="fdata.ot_policy_id" :options="ot_policies"></b-form-select>
                            </b-form-group>
                        </div>

                        <div class="col-sm-6" v-if="penalty == 1">
                            <b-form-group id="penalty_policy_id-group" label="Penalty Policy" label-for="penalty_policy_id">
                            <b-form-select id="penalty_policy_id" name="penalty_policy_id" v-model="fdata.penalty_policy_id" :options="penalty_policies"></b-form-select>
                            </b-form-group>
                        </div>

                    </div>

                    <div class="mt-3 text-center">
                        <b-button type="submit">Submit</b-button>
                        <b-button class="ml-2 custom-wizard-btn" @click="resetForm()">Reset</b-button>
                    </div>




              </b-form>
            </div>
          </b-overlay>
        </b-modal>

    </div>
</template>


<script>
    export default{
        props: [],
        data(){

            let sortOrders = {};
            let columns = [
                            {label: 'Name', name: 'title' },
                            {label: 'Employee Type', name: 'is_roster' },
                            {label: 'Holiday Enabled', name: 'holiday' },
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});

            return {
              cu : window.location.href,
              ce : true,
              c : 0,
              employeeTypeOptions:[{
                text: 'General Employees',
                value: 0,
              },{
                text: 'Roster Employees',
                value: 1,
              },],
              employeeTypes:['General', 'Roster'],
              pagetitle: 'Leave & Attendance Policy',
              search:'',
              openLeaveTypeDropdown: false,
              leavepolicy_title : [],
              ot_policies : [],
              penalty_policies : [],
              leavepolicies : [],
              leavetypes : [],

              selected_policy_id : 0,
              selected_policy_title : '',

              successmsg : '',
              errormsg : [],
              shiftData : [],
              patternOptions : [],
              blankmsg : 'Fetching data..',
              fdata : {id:0, title: '', is_roster: 0,holiday:0,ot_policy_id: 0,penalty_policy_id: 0,shift_id: 0,offday_id: 0,leave_type_ids: [], long_service_status:0},
              ldata : {},
              penalty: 0,
              overtime: 0,
              roster: 0,

              showoverlay : false,
              showoverlaymodal : false,

              yes_no:[
                  { value: "0", text: "No" },
                  { value: "1", text: "Yes" },
              ],

              length: 10,
              pagination: {currentPage: 1, total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},

              columns: columns,
              sortKey: 'title',
              sortOrders: sortOrders,

              temp_length: 10,
                people: 0,
                length_options: [
                    { value: 10, text: "10" },
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" },
                ],

              modalTitle: 'Add Leave & Attendance Policy',

            }
        },
      mounted() {
        document.addEventListener("click", this.handleClickOutside);
      },

      beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
      },
      methods:{

        dayLabel(val) {
          const map = { '0': 'Sun', '1': 'Mon', '2': 'Tue', '3': 'Wed', '4': 'Thu', '5': 'Fri', '6': 'Sat' };
          const key = String(val);
          return map[key];
        },

        getOffDayPatterns() {
          axios.get(this.$api_url + '/leave-attendance/offday-mapping').then(res => {
            this.patternOptions = [{value: 0, text: 'Select Off Day Pattern'}];
            this.patterns = res.data.patterns;
            let patternOptions = this.patterns.map(p => {
              let pt = JSON.parse(p.pattern);
              let ptt = pt.map(el => this.dayLabel(el));
              return {
                text: `${p.name} (${ptt.join(', ')})`,
                value: p.id
              }
            });
            this.patternOptions = [...this.patternOptions , ...patternOptions];
          }).catch(e=>{
            this.serverError(e);
          });
        },
        loadShifts() {
          this.shiftData = [{value: 0, text: 'Select Office Time Setting'}];
          axios.get('/leave-attendance/shifts', {params: { type: 'list' }}).then((response) => {
            let shiftData = response.data;
            this.shiftData = [...this.shiftData, ...shiftData];
          }).catch(e => this.serverError(e));
        },
        toggleLeaveTypeDropdown() {
          this.openLeaveTypeDropdown = !this.openLeaveTypeDropdown;
        },
        // getSelectedLeaveTypeNames(options, selectedValues, useId) {
        //   if (!selectedValues || !selectedValues.length) return '';
        //   const names = options.filter(o => selectedValues.includes(useId ? o.id : o.name)).map(o => o.name);
        //   if (names.length <= 3)
        //     return names.join(', ');
        //   return names.slice(0, 3).join(', ') + ` +${names.length - 2} more`;
        // },

        getSelectedLeaveTypeNames() {
          let names = [];
          let selectedIds = Array.isArray(this.fdata.leave_type_ids)
              ? this.fdata.leave_type_ids.map(x => parseInt(x))
              : [];

          for (let i = 0; i < this.leavetypes.length; i++) {
            let item = this.leavetypes[i];

            if (selectedIds.includes(parseInt(item.id))) {
              names.push(item.title);
            }
          }

          return names.join(", ");
        },

        handleClickOutside(event) {
          let dropdown = this.$refs.leave_type_dropdown;

          if (!dropdown) {
            return;
          }

          if (!dropdown.contains(event.target)) {
            this.openLeaveTypeDropdown = false;
          }
        },
          getAcl: function()
          {
              axios.get(this.$api_url+'/acl' , {
                  params: {
                      url: this.cu
                  }
              }).then(function(response){
                  this.ce = response.data;
              }.bind(this));
          },
          fake()
          {
              this.c = this.c + 1;
          },

          getTypeList: function()
          {
              if(!this.checkNet()) return false;

              axios.get(this.$api_url+'/leave-attendance/leave/types').then(function(response){
                this.leavetypes = response.data;
                this.leavetypes = this.leavetypes.filter(el => el.title != 'Compensatory Leave' && el.title != 'Long Service Leave');
              }.bind(this));
          },
          getPolicyList: function()
          {
              if(!this.checkNet()) return false;
              this.showoverlay = true;

              let arr = [];
              axios.get(this.$api_url+'/leave-attendance/leave/policies').then((response) => {
                  this.leavepolicies = response.data;

                  response.data.forEach(element => {
                      arr[element.id] = element.title;

                  });

                  this.leavepolicy_title = arr;
                  this.pagination.total = response.data.length;
                  this.showoverlay = false;
                  if(this.leavepolicies.length == 0)
                      this.blankmsg = "Nothing found.";
              });
          },

        getPenaltyPolicyList: function () {
          if (!this.checkNet()) return false;
          let arr = [];
          this.penalty_policies = [{value: 0, text: 'Select Penalty Policy'}];
          axios.get(this.$api_url + '/leave-attendance/penalty/policy/index').then((response) => {
            response.data.forEach(element => {
              arr.push({value: element.id, text: element.name});
            });

            this.penalty_policies = [...this.penalty_policies, ...arr];
          }).catch((error) => {
            this.serverError(error);
          });
        },

          getOTPolicyList: function()
          {
              if(!this.checkNet()) return false;
              this.showoverlay = true;

              let arr = [];
            this.ot_policies = [{value: 0, text: 'Select Overtime Policy'}];
              axios.get(this.$api_url+'/leave-attendance/overtime/policy/index').then((response) => {
                  response.data.forEach(element => {
                    arr.push({value: element.id, text: element.name});
                  });

                  this.ot_policies = [...this.ot_policies, ...arr];
              });
          },
        editLeavePolicy:function(x)
        {
          if(!this.checkNet()) return false;
          this.errormsg = [];
          this.successmsg = '';
          this.modalTitle = 'Edit Leave & Attendance Policy';

          axios.get(this.$api_url+'/leave-attendance/leave/policy/details/'+x).then((response) => {
            this.fdata = response.data;

            if (!Array.isArray(this.fdata.leave_type_ids))
            {
              if (this.fdata.leave_type_ids == null || this.fdata.leave_type_ids === '')
              {
                this.fdata.leave_type_ids = [];
              }
              else if (typeof this.fdata.leave_type_ids === 'string')
              {
                this.fdata.leave_type_ids = this.fdata.leave_type_ids
                    .split(',')
                    .map(x => parseInt(x))
                    .filter(x => !isNaN(x));
              }
              else
              {
                this.fdata.leave_type_ids = [];
              }
            }
            else
            {
              this.fdata.leave_type_ids = this.fdata.leave_type_ids
                  .map(x => parseInt(x))
                  .filter(x => !isNaN(x));
            }

            this.$validator.reset();
          })
              .catch((error) => {
                this.serverError(error);
              });

          this.$bvModal.show('bv-modal-leave_policies');
        },
          deleteLeavePolicy:function(x)
          {
              if(!this.checkNet()) return false;
              this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this leave & attendance policy.', {
                  title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'border-0 d-flex justify-content-center', hideHeaderClose: false,centered: true, bodyClass:"text-center"
              })
              .then(value => {
                  if(value) {
                      let formData = new FormData();
                      formData.append('id', x);

                      axios.post(this.$api_url+'/leave-attendance/leave/policy/delete', formData).then((response) => {

                          if(response.data.status == true)
                          {
                              this.$bvToast.toast(response.data.meg, {
                                          title: `Success`,
                                          variant: 'success',
                                          solid: true
                                      });

                              this.getPolicyList();
                          }
                          else
                          {
                              //this.warningmsg = response.data.meg;
                              //alert(response.data.meg);
                              this.$bvToast.toast(response.data.meg, {
                                          title: `Warning`,
                                          variant: 'warning',
                                          solid: true
                                      });
                          }


                      }).catch( (error) => {
                          this.serverError(error);
                      });
                  }
              })
              .catch(err => {
                this.serverError(err);
              })
          },
          validateState(ref)
          {
              if (
                  this.veeFields[ref] &&
                  (this.veeFields[ref].dirty || this.veeFields[ref].validated)
              ) {
                  return !this.veeErrors.has(ref);
              }
              return null;
          },
        resetForm()
        {
          this.fdata = {id:0, title: '', is_roster: 0,holiday:0,ot_policy_id: 0,penalty_policy_id: 0,shift_id: 0,offday_id: 0,leave_type_ids: [], long_service_status:0};

          this.openLeaveTypeDropdown = false;
        },
          addNewLeavePolicy()
          {
              this.modalTitle = 'Add Leave & Attendance Policy';
              this.resetForm();
              this.$bvModal.show('bv-modal-leave_policies');
          },
          onSubmit(e)
          {

            if(this.fdata.is_roster == 0){
              this.fdata.holiday = 1;
            }
              if(!this.checkNet()) return false;
              this.$validator.validateAll().then(result => {
                  if (!result) {
                      return;
                  }
                  this.showoverlaymodal = true;
                  e.preventDefault();

                  let formData = new FormData();

                  for (let [key, value] of Object.entries(this.fdata))
                  {
                      var nm = `${key}`;
                      var fval = `${value}`;
                      if(key == 'leave_type_ids') {
                        formData.append(nm, value.join(','));
                      }
                      else {
                        formData.append(nm, fval);
                      }
                  }

                  axios.post(this.$api_url+'/leave-attendance/leave/policy/save', formData).then( (response) => {
                                  this.leavepolicies = response.data;
                                  this.$bvToast.toast('Saved!', {
                                          title: `Success`,
                                          variant: 'success',
                                          solid: true
                                      });

                                  this.$bvModal.hide('bv-modal-leave_policies');
                                  this.showoverlaymodal = false;
                                  this.resetForm();

                              }).catch((error) => {
                                  this.serverError(error);
                                  this.errormsg = error.response.data.errors;
                                  for (var data in this.errormsg)
                                  {
                                    var msg = currentObj.errormsg[data];
                                    this.$bvToast.toast(msg, {
                                          title: `Error`,
                                          variant: 'danger',
                                          solid: true
                                      });
                                    this.$validator.reset();
                                  }
                              });
              });
          },


        getCompanyLeaveSettings:function()
        {
          if(!this.checkNet()) return false;
          axios.get(this.$api_url+'/leave-attendance/company/leave/settings').then(function(response){

            if(response.data.length != 0)
            {
              this.roster = response.data.roster;
              this.penalty = response.data.penalty;
              this.overtime = response.data.overtime;
            }
          }.bind(this));
        },

      },
      created: function(){
          this.getPolicyList();
          this.getTypeList();
          this.getOTPolicyList();
          this.getPenaltyPolicyList();
          this.loadShifts();
          this.getOffDayPatterns();
          this.getCompanyLeaveSettings();
          Fire.$on('reloadUsers', () => {this.getPolicyList()})
      },
      computed:
      {
          filteredData()
          {
              let filtered_list = this.leavepolicies;
              this.people = filtered_list.length;
              if (this.search)
              {
                  filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                  if(filtered_list.length == 0)
                      this.blankmsg = "Nothing found.";
              }

              let sortKey = this.sortKey;
              let order = this.sortOrders[sortKey] || 1;
              if (sortKey)
              {
                  filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                          a = String(a[sortKey]).toLowerCase();
                          b = String(b[sortKey]).toLowerCase();
                          if (this.columns[index].type && this.columns[index].type == 'date')
                          {
                              return (a == b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                          }
                          else if (this.columns[index].type && this.columns[index].type == 'number')
                          {
                              return (+a == +b ? 0 : +a > +b ? 1 : -1) * order;
                          }
                          else
                          {
                              return (a == b ? 0 : a > b ? 1 : -1) * order;
                          }
                      }
                  );
              }

              return filtered_list;
          },
          paginatedData()
          {
              return this.paginate(this.filteredData, this.temp_length, this.pagination.currentPage);
          }
      }
    }
</script>

